import { MAX_CHART_RESULTS } from '../Pae/components/BarometerResults/types';
import { useBarometerRawData } from '../Pae/components/BarometerResults/useFetchBarometerResults';
import {
  createDataPoint,
  type BarometerChartDataPoint,
} from '../Pae/components/BarometerResults/utils';

export const useBarometerChartData = (): {
  data: BarometerChartDataPoint[] | undefined;
  isLoading: boolean;
  error: Error | null;
} => {
  const { data: rawData, isLoading, error } = useBarometerRawData();

  if (!rawData) {
    return { data: undefined, isLoading, error: error ?? null };
  }

  const sortedResults = rawData
    .filter(result => result.completedAt)
    .sort(
      (a, b) => new Date(a.completedAt ?? 0).getTime() - new Date(b.completedAt ?? 0).getTime()
    );

  const chartData = sortedResults
    .slice(-MAX_CHART_RESULTS)
    .map((result, index) => createDataPoint(result, index));

  return { data: chartData, isLoading, error: error ?? null };
};
